import React from 'react';
import {useTranslation} from "react-i18next";
import Graphic from "../../../../../resources/images/mailhistory.svg";
import EmptyState from "../../../feeback/State/Empty";

const Empty = () => {
    const {t} = useTranslation();
    return (
        <EmptyState
            title={t('mail_history_empty_title')}
            textI18Key='mail_history_empty_text'
            graphic={Graphic}
        />
    );

};

export default Empty;